const initialState = []

export default function blocklistReducer(state = initialState, action) {
  switch (action.type) {
    case 'BLOCKLIST_LOAD': {
      return [...action.payload]
    }

    case 'BLOCKLIST_ADD': {
      return [...state, ...action.payload]
    }

    default:
      return state
  }
}
